import CustomerJobFeedbackBody from "components/ChallengeComponents/ChallengeDetailsComponents/JobFeedbackComponents/CustomerJobFeedbackBody";
import React from "react";

const CustomerJobFeedback = () => {
  return <CustomerJobFeedbackBody />;
};

export default CustomerJobFeedback;
